import routeMap from './routeMap'
import tabbar from './tabbarRoute'

const routes = [...tabbar, ...routeMap]

export default routes